import Product from '@/modules/inventory/models/Product';

export default class OrderLine {
    public orderLineId: number = 0;
    public product: Product;
    public productId: number = 0;
    public productAmount: number = 0;
    public orderedAmount: number = 0;
    public productPrice: number = 0;
    public description: string = '';
    public sortOrder: number = 0;
    public serialNumber: string = '';

    constructor(obj?: Partial<OrderLine>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
